export const routes = (parentName) => {
  return [
    {
      path: "blog",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-BlogList`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-BlogNew`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "BlogView",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "BlogEdit-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
